import type { IExtendedRouteObject } from "../types";
import { path as financialPath } from "../financial/path";

import { path } from "./path";

import type { ILoaderData } from "@pages/panelPages/chargeWallet/chargeWallet";
import { useUIStore } from "@/stores/uiStore";

export const chargeWalletRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.chargeWallet.route,
      lazy: () => import("@pages/panelPages/chargeWallet/chargeWallet"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.chargeWallet",
          [
            {
              title: "pageTitle.patientWallet",
              url: financialPath.wallet.link(),
            },
          ],
          "index",
        );
        return { id: params.id! };
      },
    },
    permissions: ["super-admin"],
  },
];
